import MainProvider from 'contexts/MainProvider';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'utils/init-sentry';

import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <MainProvider>
    <App />
  </MainProvider>,
);
reportWebVitals();
